module.exports = __webpack_public_path__ + "static/media/Children-and-Dog---Charcoal.95edff16.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Children-and-Dog---Charcoal.jpg
 ** module id = 426
 ** module chunks = 0
 **/